module.exports = __webpack_public_path__ + "img/ad-home-lg.b46003fb.jpg";